export enum SalesMetricColumns {
  Alerts = "Alerts",
  Type = "Type",
  Baseline = "Baseline",
  BaselineMethod = "Baseline Method",
  BaselineMatchCount = "Baseline Match Count",
  BaselineMatchQuality = "Baseline Match Quality",
  BaselineInfo = "Baseline Info",
  Adjustments = "Adjustments",
  AdjustmentsPct = "Adjustment (%)",
  AddedQuantityStockout = "Added Quantity Stockout",
  AddedQuantityMissing = "Added Quantity Missing",
  AddedQuantityDiscount = "Added Quantity Discount",
  PreorderChange = "Preorder Change",
  ExpectedPreorderChange = "Forecasted Preorder Change",
  BaselinePreOrders = "Baseline Preorders",
  // CategoryTrend = "Category Trend",
  // ColorTrend = "Color Trend",
  // BaseColorTrend = "Base Color Trend",
  // GenderTrend = "Gender Trend",
  // PreOrderTrend = "Preorder Trend",
  RiskBuyForecast = "Risk buy",
  RiskBuyForecastPct = "Risk buy (%)",
  RiskBuyForecastComparison = "Risk buy Vs Baseline",
  RiskBuyForecastComparisonPct = "Risk buy Vs Baseline (%)",

  PreordersVsBaseline = "Preorders Vs Baseline Preorders",
  PreordersVsBaselinePct = "Preorders Vs Baseline Preorders (%)",

  FinalForecast = "Expected demand",
}

export enum TrimMetricsColumns {
  PreorderQuantity = "Preorder Quantity",
  ExpectedPreorders = "Forecasted Preorders",
  CustomerInterest = "Customer Interest",
  Cannibalisation = "Cannibalisation",
  SourcingRisk = "Sourcing Risk",
  TrimAction = "Trim Action",
  CustomerCount = "Customer Count",
  CustomerCoverage = "Customer Coverage",
  AvgQuantityPerCustomer = "Avg Quantity Per Customer",
}
